/**
 * Close the whiteboard collaboration session.
 * {{
 *      type: RESET_WHITEBOARD
 * }}
 */
export const RESET_WHITEBOARD = 'RESET_WHITEBOARD';
/**
 * Configure the whiteboard collaboration details.
 * {{
 *      type: SETUP_WHITEBOARD,
 *      collabDetails
 * }}
 */
export const SETUP_WHITEBOARD = 'SETUP_WHITEBOARD';
/**
 * Sets the whiteboard visibility state.
 * {{
 *      type: SET_WHITEBOARD_OPEN,
 *      isOpen
 * }}
 */
export const SET_WHITEBOARD_OPEN = 'SET_WHITEBOARD_OPEN';
export const SET_WHITEBOARD_URL = 'SET_WHITEBOARD_URL';
export const SET_WHITEBOARD_INFO = 'SET_WHITEBOARD_INFO';
